import { Box, KsyosLogo, Loader } from '@ksyos/design-system';
import { useParams } from '@ksyos/router';
import { useState } from 'react';
import { getLanguage } from '@common/translate/translate';
import { LoginTitle, StyledContainer, StyledForm } from '../../notLoggedIn/LoginStyledComponents';
import { AccountRequestProvider } from '../AccountRequestContextProvider';
import {
    AccountRequestReviewByOrganizationView,
    AccountRequestReviewByOrganizationViews,
} from './AccountRequestReviewByOrganizationViews';

export function AccountRequestReviewByOrganizationPage() {
    const translate = getLanguage();

    const { accountRequestId } = useParams() as { accountRequestId: string };
    const [view, setView] = useState<AccountRequestReviewByOrganizationView>(
        AccountRequestReviewByOrganizationView.reviewingRequest
    );

    return (
        <AccountRequestProvider accountRequestId={accountRequestId}>
            {({ isLoading }) => (
                <StyledContainer>
                    {isLoading && <Loader size="large" />}

                    {!isLoading && (
                        <>
                            <StyledForm submitOnEnter={false}>
                                <Box textAlign="center">
                                    <KsyosLogo />
                                    <LoginTitle
                                        mt={4}
                                        textAlign="center"
                                    >
                                        {getTitle()}
                                    </LoginTitle>
                                </Box>
                                <AccountRequestReviewByOrganizationViews
                                    currentView={view}
                                    handleViewChange={setView}
                                />
                            </StyledForm>
                        </>
                    )}
                </StyledContainer>
            )}
        </AccountRequestProvider>
    );

    function getTitle() {
        if (view === AccountRequestReviewByOrganizationView.reviewingRequest) {
            return translate.accountRequest.reviewRequest;
        } else if (view === AccountRequestReviewByOrganizationView.requestApproved) {
            return translate.accountRequest.accountApproved;
        } else if (view === AccountRequestReviewByOrganizationView.rejectingRequest) {
            return translate.accountRequest.declineAccountRequest;
        } else if (view === AccountRequestReviewByOrganizationView.requestDenied) {
            return translate.accountRequest.accountDenied;
        } else if (view === AccountRequestReviewByOrganizationView.wrongApprover) {
            return translate.accountRequest.wrongApprover;
        }
    }
}
